export function downloadTextFile(content: string, filename: string, mimetype: string): void {
  // eslint-disable-next-line no-restricted-globals
  const blob = new Blob([content], { type: mimetype });
  // @ts-ignore
  // eslint-disable-next-line no-restricted-globals
  const url = window.URL.createObjectURL(blob, { oneTimeOnly: true });
  return downloadUrl(url, { filename });
}

export function downloadUrl(
  url: string,
  opts: {
    filename?: string | null;
    openInNewTab?: boolean;
  } = {},
): void {
  const { filename, openInNewTab } = opts;
  // eslint-disable-next-line no-restricted-globals
  const elem = window.document.createElement('a');
  elem.style.display = 'none';
  elem.href = url;
  if (filename) {
    elem.download = filename;
  }
  if (openInNewTab) {
    elem.target = '_blank';
  }
  // eslint-disable-next-line no-restricted-globals
  document.body.appendChild(elem);
  elem.click();
  // eslint-disable-next-line no-restricted-globals
  document.body.removeChild(elem);
}
